import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

import { Check } from 'lucide-vue-next';
    import { OnboardingStep } from '@/types';
    import { cn } from '@/lib/utils';
    import type { HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingGuideItem',
  props: {
    onboardingStep: {},
    type: { default: 'dark' },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(cn)('flex flex-1 flex-col items-center gap-2 px-1', props.class))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex size-7 items-center justify-center rounded-full border-2", {
                'bg-foreground': _ctx.onboardingStep.is_completed && _ctx.type === 'dark',
                'bg-white': _ctx.onboardingStep.is_completed && _ctx.type === 'light',
                'border-foreground text-white': _ctx.type === 'dark',
                'text-foreground border-white': _ctx.type === 'light',
            }])
    }, [
      (_ctx.onboardingStep.is_completed)
        ? (_openBlock(), _createBlock(_unref(Check), {
            key: 0,
            class: "size-4"
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("span", {
      class: _normalizeClass(["shrink-0 text-xs whitespace-nowrap", {
                'text-foreground': _ctx.type === 'dark',
                'text-white': _ctx.type === 'light',
            }])
    }, _toDisplayString(_ctx.onboardingStep.title), 3)
  ], 2))
}
}

})